import React, { useState } from "react";
import { RickyTutorial } from "../RickyTutorial";
import { ScreenPortal } from "../MobileZoom";
import { useGlow } from "../PyroTutorial";

const MSG = '[data-testid="tour-location-madison_square"]';

// Ricky's first-visit Tour walkthrough: place a wrestler at Madison Square Arena → 300 US fans.
export function TourTutorial({ stage, benchSelector, onReward, onDone }) {
  const [glow, setGlow] = useState(null);
  useGlow(glow);

  let tut = null;
  if (stage === "place") {
    tut = <RickyTutorial key="place" noBlock stay steps={[
      { text: "SEND A WRESTLER ON TOUR, BABY! More stars, more FANS! OWWWW, my passport says it expired in 1972!" },
      { text: "DRAG OR CLICK YOUR WRESTLER, THEN CLICK A VENUE! Send those stars on the road!", target: MSG,
        onEnter: () => setGlow([benchSelector, MSG].filter(Boolean).join(", ")) },
    ]} />;
  } else if (stage === "reward") {
    tut = <RickyTutorial key="reward" noBlock exitAfter onFinish={onDone} steps={[
      { text: "DRAIN THOSE FANS BEFORE THE DAY IS DONE, BABY! Empty the location and UPGRADE YOUR ARENAS!", onEnter: () => setGlow(null) },
      { text: "HERE YOU GO, BABY! 300 FANS, ALL YOURS! Go make yourself a LEGEND! OWWWWW, my knees can't handle another world tour!", onEnter: onReward },
    ]} />;
  }

  return (
    <ScreenPortal>
      <div data-testid={`tour-tutorial-${stage}`}>{tut}</div>
      <style>{`.pyro-tut-glow { filter: brightness(1.35) drop-shadow(0 0 8px #FFE600) drop-shadow(0 0 20px #FFE600) !important; }`}</style>
    </ScreenPortal>
  );
}
